import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from '@ora/recursos/src/redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChartMaps } from "layouts/mainsection/components/CHighchartToolsTraffic";
import Highcharts from 'highcharts/highmaps';
window.Highcharts = Highcharts
// require('@highcharts/map-collection/custom/south-america');
require('@highcharts/map-collection/custom/south-america');
class RTRutasNacionalesTra extends Component {
  
  componentDidMount () {
  
    
  }
  pointsToPath = (from, to, invertArc = true) => {
    var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
        arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
    // let g = 'M' + from.x + ',' + from.y + 'Q' + arcPointX + ' ' + arcPointY + ',' + to.x + ' ' + to.y;
    let g = 'M' + from.x + ',' + from.y + ',' + to.x + ' ' + to.y;
    
    return g
  }
  render () {
   //[{year: 2002, value: 10.5}]
   let paises = []
  //  paises.push({
  //          name: this.props.data.latLongCodPais[3],
  //          id: this.props.data.latLongCodPais[2],
  //          lat: this.props.data.latLongCodPais[0],
  //          lon: this.props.data.latLongCodPais[1],
  //        })
  //  this.props.data.values.map((ii, index) => {
  //    ii.color = Highcharts.getOptions().colors[index]
  //    return ii
  //  }).forEach((itemV, index) => {
     
     this.props.data.forEach(itemD => {
       let target = paises.find(itemP => itemP.id.toString().trim().toUpperCase() === itemD.origen.isocode.toString().trim().toUpperCase())
       if (target === undefined) {
         paises.push({
           name: itemD.origen.name,
           id: itemD.origen.isocode.toString().trim().toUpperCase(),
           lat: itemD.origen.latLong[0] !== undefined ? itemD.origen.latLong[0] : 0,
           lon: itemD.origen.latLong[1] !== undefined ? itemD.origen.latLong[1] : 0,
         })
       }
       //destinos
       itemD.destinos.forEach(destino => {
        let target2 = paises.find(itemP => itemP.id.toString().trim().toUpperCase() === destino.isocode.toString().trim().toUpperCase())
        if (target2 === undefined) {
          paises.push({
            name: destino.name,
            id: destino.isocode.toString().trim().toUpperCase(),
            lat: destino.latLong[0] !== undefined ? destino.latLong[0] : 0,
            lon: destino.latLong[1] !== undefined ? destino.latLong[1] : 0,
          })
        }
       })

     })
  //  }) 
   

    //  console.log('paises', paises)
    
    return this.props.data.length > 0 ?  
    <>
    {createHChartMaps('charRTRutasNacionalesTra',
    {
      chart: {
        events: {
          load: function(){
            this.mapZoom(0.5);   
          },
        }
      },
      title: {
        text: this.props.title
      },

      legend: {
        align: 'left',
        layout: 'vertical',
        floating: true
      },

      mapNavigation: {
        enabled: true
      },

      tooltip: {
        formatter: function () {
          return this.point.name
          // return this.point.name + (
          //   this.point.lat ?
          //   '<br>Lat: ' + this.point.lat + ' Lon: ' + this.point.lon : ''
          // );
        }
      },

      plotOptions: {
        series: {
          events: {
            load: function(){
              this.mapZoom(0.2);   
            },
            legendItemClick: function() {
              
              var seriesIndex = this.index;
              var series      = this.chart.series;
                if (this.visible && this.chart.restIsHidden) {
                    
                    series.forEach(function(item, index){
                        if (!['Basemap', 'Pais'].includes(item.name))
                          item.setVisible(true, false);
                    });
                    this.chart.restIsHidden = false;
                  } else {
                    
                    series.forEach(function(item, index){
                      if (!['Basemap', 'Pais'].includes(item.name))
                        item.setVisible(false, false);
                    });
                    this.show()
                    this.chart.restIsHidden = true;
                  }
                  return false;
                }
            },
          marker: {
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#434348'
          }
        }
      },

      series: [{
        // Use the gb-all map with no data as a basemap
        mapData: Highcharts.maps['custom/south-america'],
        // mapData: [],
        name: 'Basemap',
        // data: [[res.data.data.latLongCodPais[2].toLowerCase(), 1]],
        data: this.props.data.map(item => [item.origen.isocode.toLowerCase(), 1]),
        borderColor: '#707070',
        nullColor: 'rgba(200, 200, 200, 0.3)',
        showInLegend: false
      }, {
        name: 'Separators',
        type: 'mapline',
        data: Highcharts.geojson(Highcharts.maps['custom/south-america'], 'mapline'),
        // data: [],
        color: '#707070',
        showInLegend: false,
        enableMouseTracking: false
      }, {
        // Specify cities using lat/lon
        type: 'mappoint',
        name: 'Pais',
        dataLabels: {
          format: '{point.name}'
        },
        // Use id instead of name to allow for referencing points later using
        // chart.get
        /* -9.189967,
              -75.015152, */
        data: paises
      },
    
    ]

    }, 
    chartRes => {
      this.chartMapGlobal = chartRes
      console.log('chartRes',chartRes, chartRes.get('US'))
      // console.log('chartRes', chartRes.get('Birmingham'))
      this.props.data.forEach(item => {
        console.log('item', item)
        var origen = chartRes.get(item.origen.isocode.toString().toUpperCase())
        console.log('item', origen)
        let preD = {
          id: item.isocode,
          // name: itemVV.exp_txt_taxon + `(${itemVV.cantidad})`,
          name: 'Especie',
          type: 'mapline',
          lineWidth: 4,
          // color: itemVV.color,
          data: [],
          // dataLabels: {
          //   enabled: true,
          //   formatter: function () {
          //     console.log('hhhhhhhh', this)
          //     return `${this.point.total}`
          //   }
          // },
        }
        item.destinos.forEach(itemVV => {
          // itemVV.destino.forEach(itemDD => {
            let destino = chartRes.get(itemVV.isocode)
            let idd = `${origen.options.name} - ${destino.options.name}`
            preD.data.push({
                id: idd + 'hhshh',
                // name: `${idd}, Total: ${itemDD.cantidad}`,
                name: `${idd}`,
                // total: +itemDD.cantidad,
                total: 0,
                path: this.pointsToPath(origen, destino)
            })
          // })
          chartRes.addSeries(preD);
  
        })
      })
      
    }
            ) }
            <div style={{fontSize: '0.9em'}}>

              <div className="has-text-centered" style={{fontSize: '0.9em'}}>
                <p className="px-6" style={{
                color: '#000',
                fontSize: '1.1em',
                
                fill: '#000'
                }}><i>{ this.props.description }</i></p>
              </div>
              </div>
              </>
            : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(RTRutasNacionalesTra)